import { gql } from '@apollo/client';

export const GET_CURRENCY_GROUPS = gql`
  query GetCurrencyGroups($input: CurrencyGroupsInput!) {
    currencyGroups: getCurrencyGroups(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          name
          startDate
          endDate
          periodsCount
          frequency {
            id
            name
          }
          exchangeRate
          periodGroup {
            id
            name
          }
          firstPeriod {
            id
            periodDate
          }
        }
      }
    }
  }
`;
